<template>
    <div class="forget-wrap">
        <div class="ms-forget">
            <div class="ms-title">臣邦医药后台管理系统</div>
            <el-form :model="param" :rules="rules" ref="forget" label-width="0px" class="ms-content">
                <el-form-item prop="phone">
                    <el-input v-model="param.phone" placeholder="请输入手机号" @keyup.enter.native="submitForm('forget')">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        type="password"
                        placeholder="请输入新密码"
                        v-model="param.password"
                        @keyup.enter.native="submitForm('forget')"
                    >
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="again_password">
                    <el-input
                        type="password"
                        placeholder="请输入确认密码"
                        v-model="param.again_password"
                        @keyup.enter.native="submitForm('forget')"
                    >
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="code">
                    <el-input style="width: 130px" placeholder="验证码" v-model="param.code" @keyup.enter.native="submitForm('forget')">
                        <el-button slot="prepend" icon="el-icon-message"></el-button>
                    </el-input>
                    <el-link class="send-code" @click="handleSendClick">获取验证码</el-link>
                    <el-tooltip effect="dark" content="每分钟限制一次" style="margin-left: 1px" placement="top-start">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                    <el-link class="send-code" @click="handleClick()">返回登录 </el-link>
                </el-form-item>

                <div class="forget-btn">
                    <el-button type="primary" :loading="loading" @keyup.enter.native="submitForm('forget')" @click="submitForm('forget')"
                        >提 交</el-button
                    >
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'forget',
    data: function () {
        return {
            param: {
                phone: '',
                password: '',
                again_password: '',
                code: ''
            },
            rules: {
                phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
                again_password: [{ required: true, message: '请输入确认密码', trigger: 'blur' }],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
            },
            loading: false
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.$api
                        .forget(this.param)
                        .then((res) => {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.$router.replace({ path: '/login' });

                            this.loading = false;
                        })
                        .catch((error) => {
                            this.loading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        handleClick() {
            this.$router.push({
                path: '/login',
                query: {}
            });
        },
        handleSendClick() {
            this.$api
                .sendSmsCode(this.param)
                .then((res) => {
                    this.$message({
                        message: '验证码已发送，5分钟内有效',
                        type: 'success'
                    });
                })
                .catch((error) => {});
        }
    }
};
</script>

<style scoped>
.forget-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/login-bg.jpg);
    background-size: cover;
    background-repeat: no-repeat;
}
.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: rgb(80, 80, 80);
    background: rgba(255, 255, 255, 0.3);
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    /* background-image: -webkit-gradient(linear, left 0, right 0, from(rgb(248, 97, 10)), to(rgb(58, 6, 248)));
    -webkit-background-clip: text;/*必需加前缀 -webkit- 才支持这个text值 */
    /* background-clip: text; */
    /* -webkit-text-fill-color: transparent;text-fill-color会覆盖color所定义的字体颜色： */
    font-weight: bold;
}
.ms-forget {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}
.ms-content {
    padding: 30px 30px;
}
.send-code {
    font-size: 12px;
    color: #409eff;
    margin-left: 10px;
}
.forget-btn {
    text-align: center;
}
.forget-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}
.forget-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
</style>